module.exports = __webpack_public_path__ + "left-arrow-1b9667e1ace636258cb2.svg";